import Row from "@amzn/stencil-react-components/dist/submodules/layout/Row";
import withTooltip from "@amzn/stencil-react-components/dist/submodules/tooltip/withTooltip";
import { Text } from "@amzn/stencil-react-components/text";
import { IconInformationFillSmall } from "@amzn/stencil-react-icons";
import React, { FC } from "react";

import { getString } from "../../uistringlabels/uiStringUtils";

export interface PriceTextProps {
  amount?: number;
  currency?: string;
  showIcon?: boolean;
}

export const PriceText: FC<PriceTextProps> = ({ amount, currency, showIcon = true }: PriceTextProps) => {
  let priceToDisplay = "";
  const IconWithTooltip = withTooltip()(IconInformationFillSmall);

  if (amount == undefined) {
    priceToDisplay = getString("pricing.noPrice");
  } else if (amount === 0) {
    priceToDisplay = getString("pricing.free");
  } else {
    if (currency && isValidCurrencyCode(currency)) {
      try {
        priceToDisplay = `${currency} ${new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: currency,
        }).format(amount)}`;
      } catch (error) {
        priceToDisplay = `${currency} ${amount}`;
        console.warn("Failed to format currency", error);
      }
    } else {
      priceToDisplay = amount.toString();
    }
  }

  return (
    <Row>
      <Text fontSize="T400" fontWeight="regular" data-cy="price-text">
        {priceToDisplay}
      </Text>
      {showIcon && !!amount && (
        <IconWithTooltip title="Show tooltip" tooltipText={getString("ordering.costDisclaimerText")} />
      )}
    </Row>
  );
};

// Helper function to validate currency codes
function isValidCurrencyCode(code?: string): boolean {
  if (!code) return false;
  return typeof code === "string" && code.length === 3;
}
